import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from 'src/assets/locales/en-us/translation';

const resources = {
  'en-us': {
    translation: en,
  },
};

const fallbackInstance = i18next.createInstance();

fallbackInstance.use(initReactI18next).init({
  fallbackLng: 'en-us',
  lowerCaseLng: true,
  resources,
});

export default fallbackInstance;

// NOTE: this is fallback i18n config (used only if external i18n config is not passed to TranslationsProvider)
